<ngx-spinner bdColor="rgba(0,0,0,0.6)" size="medium"
  [color]="environment.theme.spinnerColor"
  type="ball-clip-rotate" [fullScreen]="true">
  <p style="color: white">{{ 'LOADER.LOADING' | translate }}</p>
</ngx-spinner>

<div [class.example-is-mobile]="mobileQuery.matches"
    [class]="!showNavComponents ? 'example-container-register' : 'example-container'">
  <mat-toolbar class="example-toolbar"
    *ngIf="showNavComponents">
    <mat-toolbar-row style="padding: 0 7px 0">
      <button [disabled]="!enableMenu" style="margin: 0 5px;" mat-icon-button aria-label="Toggle sidenav" (click)="sideBarOpened = !sideBarOpened">
        <mat-icon class="nav-hamburger-menu">menu</mat-icon>
      </button>
      <img [ngStyle]="environment.theme.navBarlogoStyling" alt="Full Logo"
        [src]="environment.theme.navBarlogo"
        (click)="homeBtn()" />
      <span class="fill-space"></span>

      <div *ngIf="!mobileQuery.matches"   [hidden]="shouldHideTenantSelection()">
        <span style="display: flex;flex-direction: row;">
          <!-- <mat-icon class="settings-icon" placeholder="Select Tenant">list_alt</mat-icon>
            <mat-select id="on-tenant-change" [(value)]="tenantId" [(ngModel)]="tenantId" (ngModelChange)="onTenantChange()" [disabled]="!enableMenu"
              class="settings-text" (openedChange)="openedChange($event)">
                <mat-option id="matOption">
                    <ngx-mat-select-search [hideClearSearchButton]="true" [placeholderLabel]="searchTenants" [clearSearchInput]="true" [noEntriesFoundLabel]="noResults"  (ngModelChange)="onTenantSearch()"
                      [(ngModel)]="selectedTenant">
                    </ngx-mat-select-search>
                </mat-option>
                <div class="nav-scrollable-container">
                  <div class="nav-scrollable" >
                    <mat-option  *ngFor="let item of filteredTenants" [value]="item.id">{{ item.name }}</mat-option>
                  </div>
                </div>
            </mat-select> -->


          <div class="settings-icon-container">
            <mat-icon class="settings-icon" placeholder="Select Tenant">list_alt</mat-icon>
          </div>
          <mat-form-field class="tenant-form-field" appearance="outline" placeholder="Select Tenant" [ngClass]="{'custom-border-color': isSelectVisible}">
            <mat-select id="on-tenant-change" [(value)]="tenantId" [(ngModel)]="tenantId"
              (ngModelChange)="onTenantChange($event)" [disabled]="!enableMenu" class="settings-text"
              (openedChange)="openedChange($event)">
              <mat-option style="background-color: white!important; padding: 8px!important">
                <div class="select-search-container-md">
                  <div class="select-search-md">
                    <ngx-mat-select-search class="select-search-sm" [hideClearSearchButton]="true"
                      [placeholderLabel]="searchTenants" [clearSearchInput]="true" [noEntriesFoundLabel]="noResults"
                      (ngModelChange)="onTenantSearch($event)" ngModel>
                    </ngx-mat-select-search>
                  </div>
                </div>
              </mat-option>
              <mat-option *ngFor="let item of filteredTenants" [value]="item.id">{{ item.name }}</mat-option>
            </mat-select>
          </mat-form-field>


        </span>
      </div>

        <div class="initial-container" id="profile-button" style="margin-left: 25px">
            <span>{{ userInitials }}</span>
        </div>

        <div *ngIf="showProfileDialog" id="profile-dialog" class="profile-dialog">
            <div class="profile-flex" style="flex-direction: row">
                <div class="initial-container" style="margin-right: 12px">
                    <span>{{userInitials}}</span>
                </div>
                <div class="profile-flex" style="flex-direction: column">
                    <span class="profile-name">{{ name }}</span>
                    <span class="profile-email">{{ email }}</span>
                </div>
            </div>

            <div style="display: flex; flex-direction: row; justify-content: space-between">
                <button class="profile-btn" (click)="showProfileDialog = false" routerLink="/profile">
                    {{'NAV-BAR.PROFILE' | translate }}
                </button>
                <button class="profile-btn" (click)="showProfileDialog = false;logout()">
                    {{'NAV-BAR.LOGOUT' | translate }}
                </button>
            </div>
        </div>

    </mat-toolbar-row>
  </mat-toolbar>

    <div style="height: 100%;width: 100%;overflow: hidden;display: flex;flex-direction: row">
    <app-side-nav *ngIf="showNavComponents"
                  [sideBarOpened]="sideBarOpened" [roles]="roles" (sideBarClose)="sideBarOpened = $event" (redirect)="redirect($event)"></app-side-nav>
        <div style="flex: 1; min-width: 0; overflow: hidden;">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
